// Validate Python code for basic syntax and structure
const validatePythonCode = (code) => {
  if (!code.trim()) {
    return { isValid: false, error: 'Code cannot be empty.' };
  }
  const lines = code.split('\n');
  const nonCommentLines = lines.filter(line => {
    const trimmed = line.trim();
    return trimmed && !trimmed.startsWith('#');
  });
  if (nonCommentLines.length === 0) {
    return { isValid: false, error: 'Code cannot contain only comments or empty lines.' };
  }
  const pythonKeywords = ['def ', 'class ', 'if ', 'for ', 'while ', 'try:', 'except', 'import ', 'from ', 'return ', 'print(', 'print '];
  const hasPythonStructure = nonCommentLines.some(line => {
    const trimmed = line.trim();
    return pythonKeywords.some(keyword => trimmed.includes(keyword)) ||
      trimmed.includes('=') ||
      trimmed.endsWith(':');
  });
  if (!hasPythonStructure) {
    return { isValid: false, error: 'Invalid code: No recognizable Python structure found. Please ensure your code contains valid Python syntax.' };
  }
  return { isValid: true, error: '' };
};

export default validatePythonCode; 